/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EmailFolderSettingDto } from '../models';
// @ts-ignore
import type { UpdateEmailFolderSettingsRequestDto } from '../models';
/**
 * RestEmailFolderSettingsApi - axios parameter creator
 */
export const RestEmailFolderSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all email folders of the user, hidden ones included, with their visibility and order
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailFolderSettings: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getEmailFolderSettings', 'userId', userId)
            const localVarPath = `/api/users/{userId}/emails/folders/settings`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save visibility and order of the user\'s email folders
         * @param {string} userId 
         * @param {UpdateEmailFolderSettingsRequestDto} updateEmailFolderSettingsRequestDto Visibility and order of the user\&#39;s email folders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailFolderSettings: async (userId: string, updateEmailFolderSettingsRequestDto: UpdateEmailFolderSettingsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateEmailFolderSettings', 'userId', userId)
            // verify required parameter 'updateEmailFolderSettingsRequestDto' is not null or undefined
            assertParamExists('updateEmailFolderSettings', 'updateEmailFolderSettingsRequestDto', updateEmailFolderSettingsRequestDto)
            const localVarPath = `/api/users/{userId}/emails/folders/settings`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmailFolderSettingsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestEmailFolderSettingsApi - functional programming interface
 */
export const RestEmailFolderSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestEmailFolderSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all email folders of the user, hidden ones included, with their visibility and order
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmailFolderSettings(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmailFolderSettingDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmailFolderSettings(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestEmailFolderSettingsApi.getEmailFolderSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Save visibility and order of the user\'s email folders
         * @param {string} userId 
         * @param {UpdateEmailFolderSettingsRequestDto} updateEmailFolderSettingsRequestDto Visibility and order of the user\&#39;s email folders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEmailFolderSettings(userId: string, updateEmailFolderSettingsRequestDto: UpdateEmailFolderSettingsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEmailFolderSettings(userId, updateEmailFolderSettingsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestEmailFolderSettingsApi.updateEmailFolderSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestEmailFolderSettingsApi - factory interface
 */
export const RestEmailFolderSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestEmailFolderSettingsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all email folders of the user, hidden ones included, with their visibility and order
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailFolderSettings(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EmailFolderSettingDto>> {
            return localVarFp.getEmailFolderSettings(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save visibility and order of the user\'s email folders
         * @param {string} userId 
         * @param {UpdateEmailFolderSettingsRequestDto} updateEmailFolderSettingsRequestDto Visibility and order of the user\&#39;s email folders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailFolderSettings(userId: string, updateEmailFolderSettingsRequestDto: UpdateEmailFolderSettingsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateEmailFolderSettings(userId, updateEmailFolderSettingsRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestEmailFolderSettingsApi - interface
 */
export interface RestEmailFolderSettingsApiInterface {
    /**
     * 
     * @summary Get all email folders of the user, hidden ones included, with their visibility and order
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEmailFolderSettings(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EmailFolderSettingDto>>;

    /**
     * 
     * @summary Save visibility and order of the user\'s email folders
     * @param {string} userId 
     * @param {UpdateEmailFolderSettingsRequestDto} updateEmailFolderSettingsRequestDto Visibility and order of the user\&#39;s email folders
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEmailFolderSettings(userId: string, updateEmailFolderSettingsRequestDto: UpdateEmailFolderSettingsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestEmailFolderSettingsApi - object-oriented interface
 */
export class RestEmailFolderSettingsApi extends BaseAPI implements RestEmailFolderSettingsApiInterface {
    /**
     * 
     * @summary Get all email folders of the user, hidden ones included, with their visibility and order
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEmailFolderSettings(userId: string, options?: RawAxiosRequestConfig) {
        return RestEmailFolderSettingsApiFp(this.configuration).getEmailFolderSettings(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save visibility and order of the user\'s email folders
     * @param {string} userId 
     * @param {UpdateEmailFolderSettingsRequestDto} updateEmailFolderSettingsRequestDto Visibility and order of the user\&#39;s email folders
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateEmailFolderSettings(userId: string, updateEmailFolderSettingsRequestDto: UpdateEmailFolderSettingsRequestDto, options?: RawAxiosRequestConfig) {
        return RestEmailFolderSettingsApiFp(this.configuration).updateEmailFolderSettings(userId, updateEmailFolderSettingsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

